/**
 * 시청 진행 보고 (v16 에서 신설).
 *
 * 특허 청구항 6 이 요구하는 것은 **주기 + 중단 이벤트** 둘이다. 그 둘을 한 엔드포인트가
 * 받는다 — `POST /v1/progress`, 응답은 **202 Accepted · 본문 없음**이다 (`/v1/events` 와
 * 같은 방침). 진행 보고가 화면을 막아서는 안 되고, **중단 보고는 문서가 사라진 뒤에 끝나
 * 응답을 받을 주체가 없다.**
 *
 * **`Event` 를 대체하지 않는다** (절대 규칙 46). `Event` 는 append-only 분석 로그이고
 * 진행은 조회용 현재 상태다. 둘을 합치면 채널을 열 때마다 시청자별 전체 로그를 스캔해야 한다.
 */
/** 특허 【0087】의 「미리 지정된 주기」 */
export const PROGRESS_REPORT_INTERVAL_MS = 10_000;
/** 한 요청이 실을 수 있는 항목 수. 넘으면 서버가 자른다 */
export const PROGRESS_BATCH_MAX = 20;
export const PROGRESS_REPORT_REASONS = [
    /** 10초 주기 */
    'interval',
    /** 한 회차가 끝났다 */
    'item_complete',
    /** 건너뛰기 */
    'skip',
    /** 목록에서 골랐다. **되감기가 허용되는 유일한 값이다** */
    'select',
    /** 다른 채널로 */
    'channel_switch',
    /**
     * 화면이 숨거나 닫힌다 (`pagehide`·`visibilitychange`).
     *
     * **`fetch(..., { keepalive: true })` 로 보낸다 — `sendBeacon` 이 아니다** (v18).
     * 그쪽은 `Authorization` 을 실을 수 없어 **계정 축에 닿지 못하고**, 축이 계정 하나가 된
     * 지금은 서버가 그 요청을 버린다. 증상은 「끄기 직전 10초가 항상 사라진다」 하나이고
     * 조용하다. **`beforeunload` 도 쓰지 않는다** — iOS Safari·WKWebView 에서 신뢰할 수 없다.
     */
    'teardown',
];
export function isProgressReportReason(value) {
    return PROGRESS_REPORT_REASONS.includes(value);
}
//# sourceMappingURL=progress.js.map